import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { ShieldAlert } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { routes } from '@/lib/routes'
import { useOptionalAuth } from '@/contexts/auth-context'
import { useI18n } from '@/i18n'

export function ImpersonationBanner() {
  const i18n = useI18n()
  const auth = useOptionalAuth()
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const handleSwitchBack = useCallback(async () => {
    if (!auth) return
    await auth.stopImpersonation()
    queryClient.removeQueries()
    navigate(routes.dashboard())
  }, [auth, queryClient, navigate])

  if (!auth || !auth.isImpersonating || !auth.user?.originalUser) return null
  const {user} = auth
  if (!user || !user.originalUser) return null
  const {originalUser} = user

  return (
    <div className="bg-amber-500 text-amber-950 px-4 py-2 text-center text-sm font-medium
                    flex items-center justify-center gap-3 sticky top-0 z-50">
      <ShieldAlert className="h-4 w-4" />
      <span>
        {i18n.impersonation.impersonating} <strong data-testid="impersonated-user-name">{user.name}</strong> {i18n.impersonation.impersonatingSuffix({email: user.email, originalName: originalUser.name})}
      </span>
      <Button
        variant="outline"
        size="sm"
        onClick={handleSwitchBack}
        className="bg-amber-600 border-amber-700 text-amber-950 hover:bg-amber-700"
        data-testid="btn-switch-back"
      >
        {i18n.impersonation.switchBack}
      </Button>
    </div>
  )
}
